import { Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { BackBtn } from '../BackBtn';

interface IScreenCardHeaderProps extends PropsWithChildren {
  title?: string;
  backBtn?: {
    to: string;
    label: string;
  };
}

export const ScreenCardHeader = ({
  title,
  backBtn,
}: IScreenCardHeaderProps): JSX.Element => {
  return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        pb={3}
        sx={{
          position: 'relative',
        }}
      >
        {backBtn && (
          <BackBtn
            to={backBtn.to}
            label={backBtn.label}
            sx={{
              position: 'absolute',
              left: 0,
            }}
          />
        )}

        {title && (
          <Typography
            sx={{
              display: {
                xs: 'none',
                sm: 'block',
              },
            }}
            variant="h6"
          >
            {title}
          </Typography>
        )}
      </Stack>
  );
};
